// extracted by mini-css-extract-plugin
export default {"labelText":"OverviewInternalOrderIdSection_labelText__-dN2h","valueText":"OverviewInternalOrderIdSection_valueText__GOuIW"};